import AbstractDevice from '../all/AbstractDevice';
import ZtePlayerUtil from "./PlayerUtil";
import ZteConfig from "./config";
import AndroidId from "../android/Id";
import AndroidPlayer from "../android/Player";
import AbstractHTML5Player from '../all/AbstractHTML5Player';
import AndroidKeys from "./Keys";
import AndroidNetworkStatus from "../android/NetworkStatus";
import AndroidSystem from "../android/System";
import settings from '../all/settings';
import WorkstationKeys from '../workstation/Keys';

class ZteDevice extends AbstractDevice {
  constructor () {
    super(
      "android",
      new AndroidId(),
      settings.use_dexie ? new AbstractHTML5Player() : new AndroidPlayer(),
      new ZtePlayerUtil(),
      ZteConfig,
      settings.use_dexie? new WorkstationKeys() : new AndroidKeys(),
      new AndroidNetworkStatus(),
      new AndroidSystem(),
      "zte"
    );
  }
  
  getSubplatform() {
    return 'zte';
  }

  update_launcher (region, result){
    try {
      window.AndroidPlayerInterface && window.AndroidPlayerInterface.saveLauncher(region, JSON.stringify(result));
    }
    catch (e) {
      console.error("[Device.update_launcher]", e);
    }
  }
}

export default ZteDevice;



// WEBPACK FOOTER //
// ./src/devices/zte/Device.js